import { z } from "zod";
import { siteMethod } from "./enums";

// Mirrors the backend CreateSiteSchema (echorai-core/src/admin/admin.dto.ts).
export const siteInputSchema = z.object({
  name: z.string().min(1, "Namn krävs").max(120),
  slug: z
    .string()
    .min(1, "Slug krävs")
    .max(60)
    .regex(/^[a-z0-9-]+$/, "Endast små bokstäver, siffror och bindestreck"),
  method: siteMethod,
  instructions: z.string().max(4000).optional(),
  active: z.boolean().optional(),
  displayOrder: z.coerce.number().int().min(0).optional(),
});

export type SiteInput = z.infer<typeof siteInputSchema>;
